var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Info_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3889"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 138",
    fill: "#fff",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-information-circle",
    d: "M12.673 3.375a9.3 9.3 0 109.3 9.3 9.3 9.3 0 00-9.3-9.3zm.849 13.59h-1.707v-6.442h1.708zm-.854-7.144a.892.892 0 11.925-.894.9.9 0 01-.924.894z",
    transform: "translate(-1.173 -1.173)",
    fill: "url(#Info_svg__a)"
  }))));
};
export default SvgInfo;